module.exports = __webpack_public_path__ + "telegram-12d7507bd8bca77a5f15.svg";